export default __webpack_public_path__ + "static/media/Mark of Metamorphosis.328ad310.jpg";